module.exports = __webpack_public_path__ + "img/success.7f65e149.svg";